module.exports = __webpack_public_path__ + "fonts/Graphik-Thin.2afb95fd.woff2";